<template>
    <div id="caroussel-container" class="caroussel-container">
        <div class="caroussel" id="caroussel">
            <div class="caroussel-item" v-for="partenaire in partenairesList" :key="partenaire.id">
                <a :href="partenaire.website" target="_blank" class="partenaire-link">
                    <img :src="partenaire.sourceLogo" :alt="partenaire.name" class="logo-partenaire" />
                    <div class="nom-partenaire">
                        <span>{{ partenaire.name }}</span>
                    </div>
                </a>
            </div>
        </div>
        <div class="row caroussel-button-container">
            <button id="prev-caroussel-button" class="col-2 caroussel-button" @click="clickPrevItemCaroussel" >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="svg-caroussel-button">
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                </svg>
            </button>
            <button id="next-caroussel-button" class="col-2 caroussel-button" @click="clickNextItemCarousssel" >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="svg-caroussel-button">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CarousselPartenaire",
        props: {
            partenaires: {
                type: Array
            }
        },
        data() {
            var partenairesList = this.partenaires;
            var nbPartenaires = this.partenaires.length;
            var indexPartenaireVisible = 0;
            var idAutoCarousselInterval;
            var idLastTimeout;

            return {
                partenairesList,
                nbPartenaires,
                indexPartenaireVisible,
                idAutoCarousselInterval,
                idLastTimeout
            }
        },
        methods: {
            getRotateAngle: function() {
                return Math.round(360 / this.nbPartenaires);
            },
            getDistFromOrigin: function() {
                let itemWidth = document.getElementById("caroussel-container").offsetWidth;
                return  Math.round( ( itemWidth / 2 ) / Math.tan( Math.PI / this.nbPartenaires ) );
            },
            setNewCarousselAngle: function() {
                let refRotateAngle = this.getRotateAngle();
                let distFromOrigin = this.getDistFromOrigin();
                let newAngle = refRotateAngle * this.indexPartenaireVisible;

                document.getElementById('caroussel').style.transform = "translateZ(-" + distFromOrigin + "px) rotateY(" + newAngle + "deg)";
            },
            nextItemCaroussel: function() {
                this.indexPartenaireVisible += 1;

                this.setNewCarousselAngle();
            },
            clickNextItemCarousssel: function() {
                clearInterval(this.idAutoCarousselInterval);
                clearTimeout(this.idLastTimeout);

                this.nextItemCaroussel();
                
                this.idLastTimeout = setTimeout(this.launchAutoCaroussel(), 5000);
            },
            clickPrevItemCaroussel: function() {
                clearInterval(this.idAutoCarousselInterval);
                clearTimeout(this.idLastTimeout);

                this.indexPartenaireVisible -= 1;

                this.setNewCarousselAngle();

                this.idLastTimeout = setTimeout(this.launchAutoCaroussel(), 5000);
            },
            launchAutoCaroussel: function() {
                this.idAutoCarousselInterval = setInterval(this.nextItemCaroussel, 5000)
            }
        },
        mounted() {
            this.indexPartenaireVisible = 0;

            let carousselItems = document.getElementsByClassName('caroussel-item');
            let nbCarousselItem = this.nbPartenaires;

            let rotateAngle = this.getRotateAngle();
            let distFromOrigin = this.getDistFromOrigin();

            document.getElementById('caroussel').style.transform = "translateZ(-" + distFromOrigin + "px) rotateY(0deg)";

            for(let i = 0; i < nbCarousselItem; i++) {
                let itemAngle = i * rotateAngle;
                carousselItems[i].style.transform = "rotateY(" + itemAngle + "deg) translateZ(" + distFromOrigin + "px)";
            }

            this.launchAutoCaroussel();
        },
        unmounted() {
            clearInterval(this.idAutoCarousselInterval);
            clearTimeout(this.idLastTimeout);
        }
    }
</script>

<style lang="scss">
    .caroussel-container {
        perspective: 1000px;
        height: 50vh;
        width: 100%;
    }

    .caroussel {
        position: relative;
        height: 100%;
        width: 100%;
        transform-style: preserve-3d;
        transition: transform 2s;
    }

    .caroussel-item {
        position: absolute;
        top: 0;
        left: 10%;
        width: 80%;
        height: 100%;
        text-align: center;
    }

    .partenaire-link {
        position: absolute;
        display: flex;
        flex-direction: column;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        color: #000;
        text-decoration: none;
        margin: auto;
    }

    .partenaire-link:hover {
        color: #000;
    }

    .logo-partenaire {
        max-width: 80%;
        max-height: 70%;
        margin: auto;
        opacity: .95;
        transition: 0.3s;
    }

    .logo-partenaire:hover {
        transform: scale(1.3);
        opacity: 1;
    }

    .nom-partenaire {
        display: flex;
        width: 100%;
        height: 20%;
        justify-content: center;
        align-items: center;
    }

    .caroussel-button-container {
        margin-top: 1em;
    }

    .caroussel-button {
        font-size: 1.6em;
        border: none;
        background: transparent;
    }

    #prev-caroussel-button {
        margin-left: auto;
    }

    #next-caroussel-button {
        margin-right: auto;
    }

    .svg-caroussel-button {
        height: 1.6em;
        width: 1.6em;
        fill: #000;
        transition: transform .3s;
    }

    .caroussel-button:hover .svg-caroussel-button {
        transform: scale(1.4);
    }
</style>